/**
 * DASI — Animations d'apparition au scroll (utilitaire global).
 * Cible UNIQUEMENT les blocs perso qui n'ont pas déjà leur propre animation
 * (aroma-bars / taste-profile / fiche-infusion / astro / specialite sont gérés ailleurs).
 *
 * Comportement : l'animation se REJOUE à chaque fois que le bloc entre dans le
 * viewport. Quand le bloc en sort, ses éléments sont remis à l'état caché → ils ne
 * s'animent JAMAIS hors écran, et l'effet rejoue si on revient en arrière.
 *
 * Mécanique : .dasi-rv = état caché ; .dasi-rv-go = lance l'animation @keyframes
 * (cf. dasi-reveal.css). À la fin de l'animation, on retire les 2 classes → l'élément
 * revient à son état naturel (les :hover des sections marchent). À la sortie de
 * l'écran, on remet .dasi-rv (caché) pour pouvoir rejouer.
 *
 * Respecte prefers-reduced-motion (on ne fait rien). Sans JS, rien n'est masqué.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // { root: sélecteur du bloc, item: sélecteur des éléments à révéler en décalé }
  var CONFIG = [
    { root: '.anecdote-section', item: '.anecdote-section__visual, .anecdote-section__body > *' },
    { root: '.certifications-section', item: '.certifications-section__eyebrow, .certifications-section__title, .certification' },
    { root: '.ingredients-section', item: '.ingredients-section__inner > *' },
    { root: '.origin-map-section', item: '.origin-map__inner > *' },
    { root: '.assortiment-section', item: '.assortiment-card' },
    { root: '.reassurance-section', item: '.reassurance-item' },
    { root: '.conseil-avis-section', item: '.conseil-avis-section__inner > *' },
    { root: '.couleur-the-section', item: '.couleur-the-section__inner > *' },
    { root: '.heritage-section', item: '.heritage-card' },
    { root: '.astro-traits', item: '.astro-traits__eyebrow, .astro-traits__grid > *' },
    { root: '.bloc-perso-section', item: '.bloc-perso-section__visual, .bloc-perso-section__body > *' }
  ];

  // Fin d'animation → retour à l'état naturel (reste visible tant que dans l'écran ;
  // le :hover des sections refonctionne car plus aucune classe dasi n'est posée).
  function onAnimEnd(e) {
    if (e.animationName !== 'dasi-rv-in') return;
    e.currentTarget.classList.remove('dasi-rv', 'dasi-rv-go');
  }

  // Entrée dans l'écran → (re)lance l'animation pour tous les items du bloc.
  function showRoot(root) {
    var items = root.__dasiItems;
    if (!items) return;
    for (var i = 0; i < items.length; i++) {
      items[i].classList.add('dasi-rv');
      items[i].classList.remove('dasi-rv-go');
    }
    void root.offsetWidth; // un seul reflow → garantit le redémarrage de l'animation
    for (var j = 0; j < items.length; j++) items[j].classList.add('dasi-rv-go');
  }

  // Sortie de l'écran → remet l'état caché (prêt à rejouer à la prochaine entrée).
  function hideRoot(root) {
    var items = root.__dasiItems;
    if (!items) return;
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('dasi-rv-go');
      items[i].classList.add('dasi-rv');
    }
  }

  // Préparation : masque chaque item, mémorise la liste sur le root, écoute animationend.
  var roots = [];
  CONFIG.forEach(function (cfg) {
    var found = document.querySelectorAll(cfg.root);
    for (var i = 0; i < found.length; i++) {
      var root = found[i];
      var nodeList = root.querySelectorAll(cfg.item);
      var items;
      if (!nodeList.length) {
        root.classList.add('dasi-rv');
        root.addEventListener('animationend', onAnimEnd);
        items = [root];
      } else {
        items = [];
        for (var j = 0; j < nodeList.length; j++) {
          nodeList[j].classList.add('dasi-rv');
          nodeList[j].style.setProperty('--dasi-i', String(j < 10 ? j : 10));
          nodeList[j].addEventListener('animationend', onAnimEnd);
          items.push(nodeList[j]);
        }
      }
      root.__dasiItems = items;
      roots.push(root);
    }
  });
  if (!roots.length) return;

  // Pas d'IntersectionObserver → on révèle tout de suite (repli sûr).
  if (!('IntersectionObserver' in window)) {
    roots.forEach(showRoot);
    return;
  }

  // Déclenche quand le bloc entre vraiment dans l'écran (et masque quand il sort).
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) showRoot(entry.target);
        else hideRoot(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );
  roots.forEach(function (r) { observer.observe(r); });
})();
